import { render, staticRenderFns } from "./ClimbingTypeInput.vue?vue&type=template&id=17bf8b62"
import script from "./ClimbingTypeInput.vue?vue&type=script&lang=js"
export * from "./ClimbingTypeInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports